import React from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Tooltip from "react-tooltip";

import "./EtfFundsFlowsStyles.css";

let dataTip5D = "";
let dataTip1M = "";
let dataTip3M = "";
let dataTipYTD = "";
export default function EtfFundsFlowsTable({
  data,
  response,
  ticker2name,
  latestDate,
}) {
  const [tabValue, setTabValue] = React.useState(0);
  // const [data, setData] = React.useState([]);
  const [tabInflowData, setTabInflowData] = React.useState([]);
  const [tabOutflowData, setTabOutflowData] = React.useState([]);

  const tabLabels = ["1W", "1M", "3M", "YTD"];
  const tabValues = [7, 30, 90, 365];

  const [handler, setHandler] = React.useState("");

  React.useEffect(() => {
    const handling = (e) => setHandler({ matches: e.matches });
    window
      .matchMedia("(max-width: 480px)")
      .addEventListener("change", handling);
  }, [handler]);

  React.useEffect(() => {
    if (response) {
      const bigDataSet = generateDataset(response, tabLabels, tabValues);

      const inFlow = {};
      const outFlow = {};

      Object.keys(bigDataSet).forEach((period) => {
        const allFlow = bigDataSet[period]["Rolling Sum"];
        allFlow.forEach((elem) => {
          if (elem.value > 0) {
            if (inFlow[period] !== undefined) {
              inFlow[period].push(elem);
            } else {
              inFlow[period] = [elem];
            }
          } else if (elem.value < 0) {
            if (outFlow[period] !== undefined) {
              outFlow[period].push(elem);
            } else {
              outFlow[period] = [elem];
            }
          }
          if (inFlow[period]) {
            inFlow[period].sort((a, b) => b.value - a.value);
            inFlow[period] = inFlow[period].slice(0, 10);
          }
          if (outFlow[period]) {
            outFlow[period].sort((a, b) => a.value - b.value);
            outFlow[period] = outFlow[period].slice(0, 10);
          }
        });
      });
      setTabInflowData(
        inFlow[tabLabels[tabValue]] ? inFlow[tabLabels[tabValue]] : [],
      );
      setTabOutflowData(
        outFlow[tabLabels[tabValue]] ? outFlow[tabLabels[tabValue]] : [],
      );
      // setData({ inflow: inFlow, outflow: outFlow });
    }
    // eslint-disable-next-line
  }, [tabValue, response]);

  const generateDataset = (data, tabLabels, tabValues) => {
    const dataDict = {}; // ticker -> timestamp -> value
    for (const obj of data) {
      if (dataDict[obj.ticker] === undefined) {
        dataDict[obj.ticker] = { [obj.timestamp]: obj.fund_flow };
      } else {
        dataDict[obj.ticker][obj.timestamp] = obj.fund_flow;
      }
    }
    // difference functions
    // const percChange = (a, b) => {
    //   if (b === 0) return 0;
    //   return ((a - b) / Math.abs(b)) * 100;
    // };
    // const absChange = (a, b) => a - b;
    // const changeFunctions = { Percent: percChange, Absolute: absChange };

    const dataToReturn = {};
    for (let i = 0; i < tabLabels.length; i++) {
      const tabLabel = tabLabels[i];
      // let tabValue = tabValues[i];
      dataToReturn[tabLabel] = {};
      // for (let funcType in changeFunctions) {
      //   let valueArr = [];
      //   Object.keys(ticker2name).forEach((ticker) => {
      //     // get number
      //     const changeFunc = changeFunctions[funcType];
      //     let number = calculateChange(tabValue, dataDict[ticker], changeFunc);
      //     if (number !== undefined) {
      //       valueArr.push({ ticker: ticker, value: number });
      //     }
      //   });
      //   dataToReturn[tabLabel][funcType] = valueArr;
      // }
      // rolling sum
      const rollingSumArr = [];
      Object.keys(ticker2name)?.forEach((ticker) => {
        // get number
        const number = getRollingSum(tabValues[tabValue], dataDict[ticker]);
        rollingSumArr.push({ ticker: ticker, value: number });
      });
      dataToReturn[tabLabel]["Rolling Sum"] = rollingSumArr;
    }
    return dataToReturn;
  };

  // const getRollingSum = (tabValue, date2num) => {
  //   if (date2num === undefined) {
  //     return undefined;
  //   }
  //   const allDateStrsSorted = Object.keys(date2num).sort();
  //   const maxDateStr = allDateStrsSorted.reverse()[0];
  //   const date1 = new Date(maxDateStr);
  //   const value1 = date2num[maxDateStr];
  //   let date2 = date1;
  //   if (tabValue !== -1) {
  //     // not YTD
  //     date2.setDate(date1.getDate() - tabValue + 1);
  //   } else {
  //     // keep same year, set the rest to Jan 1
  //     date2.setDate(1);
  //     date2.setMonth(0);
  //   }
  //   date2.setDate(date1.getDate() - tabValue + 1);

  //   let value2 = undefined;
  //   for (let count = 0; count < 10; count++) {
  //     date2.setDate(date2.getDate() - 1);
  //     let date2Str = date2.toISOString().split("T")[0];
  //     value2 = date2num[date2Str];
  //     if (value2 !== undefined) {
  //       break;
  //     }
  //   }
  //   if (value2 === undefined) {
  //     return undefined;
  //   }

  //   let rollingSum5 = value2;
  //   let numValues = 1;
  //   let maxTries = 100;
  //   let currDate = date2;
  //   let value = undefined;
  //   while (numValues < 5) {
  //     currDate.setDate(currDate.getDate() - 1);
  //     let dateCurrStr = currDate.toISOString().split("T")[0];
  //     value = date2num[dateCurrStr];
  //     if (value !== undefined) {
  //       numValues += 1;
  //       rollingSum5 += value;
  //     }
  //     maxTries -= 1;
  //     if (maxTries === 0) return undefined; // something went wrong
  //   }
  //   return rollingSum5;
  // };
  //sort the data based on date and add the daily net flow of the ticker up to
  //the end of the timeframe that is to be displayed
  const getRollingSum = (tabValue, date2num) => {
    let aggregate = 0;
    const timeframe = new Date();
    timeframe.setDate(timeframe.getDate() - tabValue);
    try {
      const sortDate2NumKeys = Object.keys(date2num)?.sort(
        (a, b) => new Date(b) - new Date(a),
      );

      sortDate2NumKeys.forEach((date) => {
        if (
          timeframe.toISOString().split("T")[0] <=
          new Date(date).toISOString().split("T")[0]
        ) {
          aggregate += date2num[date];
          //logic for detecting YTD
          if (
            tabValue === 365 &&
            new Date(date) <= new Date(new Date().getFullYear() + "-01-01")
          ) {
            aggregate -= date2num[date];
          }
        }
      });
    } catch (e) {
      console.log("error ", e);
    }

    return aggregate;
  };

  const dataTipDate = (date, subtractDays) => {
    let newDate = "";
    if (subtractDays === "YTD")
      newDate = new Date(new Date().getFullYear(), 0, 1).toLocaleDateString(
        "fr-CA",
      );
    else
      newDate = new Date(
        date.setDate(date.getDate() - subtractDays),
      ).toLocaleDateString("fr-CA");

    return newDate.charAt(5) === "0"
      ? "4:30PM " + newDate.substring(6) + "-" + newDate.substring(0, 4)
      : "4:30PM " + newDate.substring(5) + "-" + newDate.substring(0, 4);
  };

  const formatDate = (date) => {
    let temp = new Date(date);
    if (date) {
      const subtractDay =
        tabValue === 0
          ? 0
          : tabValue === 1
          ? 7
          : tabValue === 3
          ? 30
          : tabValue === 4
          ? 90
          : 120;
      date = temp.setDate(temp.getDate() - subtractDay);
      date = new Date(date).toISOString();
      console.log(date);
      let newDate =
        date.charAt(5) === "0"
          ? date.substring(6) + "-" + date.substring(0, 4)
          : date.substring(5) + "-" + date.substring(0, 4);
      if (tabValue === 0) {
        temp = new Date(date);
        dataTip5D = dataTipDate(temp, 5);
        temp = new Date(date);
        dataTip1M = dataTipDate(temp, 30);
        temp = new Date(date);
        dataTip3M = dataTipDate(temp, 87);
        temp = new Date(date);
        dataTipYTD = dataTipDate(temp, "YTD");
        date = data[0]?.data?.timestamp;
        let formatTime =
          parseInt(
            date?.substring(date.indexOf("T") + 1, date.indexOf("T") + 6),
          ) - 5;
        if (formatTime < 12) formatTime += ":30AM";
        else if (formatTime === 12) formatTime += ":30PM";
        else formatTime = (formatTime % 12) + ":30PM";
        newDate = formatTime + " " + newDate;
      } else newDate = "4:30PM " + newDate;

      return newDate;
    }
  };

  formatDate(latestDate);

  return (
    <div className="App" style={{ padding: 10 }}>
      <div style={{ color: "white", fontSize: 18, textAlign: "center" }}>
        ETF Fund Flows
      </div>
      <div
        style={{
          paddingTop: 3,
          color: "white",
          fontSize: 12,
          textAlign: "center",
          fontStyle: "italic",
        }}
      >
        Data updates after market close
      </div>
      <div
        className="cross-asset-class-volatility"
        style={{ display: "flex", justifyContent: "center" }}
      >
        <div className="buttons">
          <div
            data-tip={dataTip5D}
            className={`button ${tabValue === 0 ? "selected" : ""}`}
            onClick={() => {
              setTabValue(0);
            }}
          >
            1W
          </div>
          <div
            data-tip={dataTip1M}
            className={`button ${tabValue === 1 ? "selected" : ""}`}
            onClick={() => {
              setTabValue(1);
            }}
          >
            1M
          </div>
          <div
            data-tip={dataTip3M}
            className={`button ${tabValue === 2 ? "selected" : ""}`}
            onClick={() => {
              setTabValue(2);
            }}
          >
            3M
          </div>
          <div
            data-tip={dataTipYTD}
            className={`button ${tabValue === 3 ? "selected" : ""}`}
            onClick={() => {
              setTabValue(3);
            }}
          >
            YTD
          </div>
        </div>
      </div>

      <div
        className="Tables"
        style={{
          display: window.matchMedia("(max-width: 480px)").matches
            ? "block"
            : "flex",
          width: window.matchMedia("(max-width: 480px)").matches
            ? "700px"
            : "100%",
          margin: "auto",
        }}
      >
        <div className="Inflows" style={{ width: "50%", padding: 25 }}>
          <p
            className="Titles"
            style={{ backgroundColor: "#75ce41", margin: "auto" }}
          >
            {`Top 10 Inflows / Additions ($ millions)`}
          </p>
          <TableContainer>
            <Table className="TableFlow">
              <TableHead>
                <TableRow>
                  <TableCell align="left" style={{ color: "white" }} />
                  <TableCell align="left" style={{ color: "white" }}>
                    Ticker
                  </TableCell>
                  <TableCell
                    align="left"
                    style={{ color: "white" }}
                  ></TableCell>
                  <TableCell align="right" style={{ color: "white" }}>
                    Net Flow
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {tabInflowData.map((elem, index) => {
                  const val = `+$${parseFloat(elem.value.toFixed(0))}`;
                  return (
                    <TableRow key={index}>
                      <TableCell align="left" style={{ color: "white" }}>
                        {index + 1}
                      </TableCell>
                      <TableCell align="left" style={{ color: "white" }}>
                        {ticker2name[elem.ticker]?.split(",")[0]}
                      </TableCell>
                      <TableCell
                        align="left"
                        style={{ color: "white" }}
                      ></TableCell>
                      <TableCell align="right" style={{ color: "#75ce41" }}>
                        {val.slice(0, 2)}
                        {parseInt(
                          val.slice(2, val.length + 1),
                        ).toLocaleString()}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        <div className="vl"></div>
        <div className="Outflows" style={{ width: "50%", padding: 25 }}>
          <p
            className="Titles"
            style={{ backgroundColor: "#d33541", margin: "auto" }}
          >
            {`Top 10 Outflows / Additions ($ millions)`}
          </p>
          <TableContainer>
            <Table className="TableFlow">
              <TableHead>
                <TableRow>
                  <TableCell align="left" style={{ color: "white" }} />
                  <TableCell align="left" style={{ color: "white" }}>
                    Ticker
                  </TableCell>
                  <TableCell
                    align="left"
                    style={{ color: "white" }}
                  ></TableCell>
                  <TableCell align="right" style={{ color: "white" }}>
                    Net Flow
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {tabOutflowData.map((elem, index) => {
                  const val = `-$${Math.abs(
                    parseFloat(elem.value.toFixed(0)),
                  )}`;
                  return (
                    <TableRow key={index}>
                      <TableCell align="left" style={{ color: "white" }}>
                        {index + 1}
                      </TableCell>
                      <TableCell align="left" style={{ color: "white" }}>
                        {ticker2name[elem.ticker]?.split(",")[0]}
                      </TableCell>
                      <TableCell
                        align="left"
                        style={{ color: "white" }}
                      ></TableCell>
                      <TableCell align="right" style={{ color: "#d33541" }}>
                        {val.slice(0, 2)}
                        {parseInt(
                          val.slice(2, val.length + 1),
                        ).toLocaleString()}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
          <Tooltip />
        </div>
      </div>
    </div>
  );
}
